import { RequestService } from '../../../../../common/services/RequestService';
import { API_AUTHORIZATION } from '../../constants';

export const loginRequest = payload => {
  return RequestService.post(API_AUTHORIZATION, payload).then(
    response => response
  );
};
